import { Account } from 'views/account';
import { Profile } from 'views/account/profile';
import { Users } from 'views/account/users';
import { Subscription } from 'views/account/subscription';
import { BuyVolume } from 'views/account/BuyVolume';
import { ChangePlan } from 'views/account/ChangePlan';
import { Password } from 'views/account/password';
import { Organization } from 'views/account/organization';
import { Navigate } from 'react-router-dom';
import { ProjectAccess } from 'views/account/ProjectAccess';

const Routes = [
  {
    path: '/account',
    view: Account,
    layout: 'app',
    title: 'Your Account',
  },
  {
    path: '/account/profile',
    view: Profile,
    layout: 'app',
    title: 'Your Profile',
  },
  {
    path: '/account/password',
    view: Password,
    layout: 'app',
    title: 'Change Password',
  },
  {
    path: '/account/organization',
    view: Organization,
    layout: 'app',
    permission: 'owner',
    title: 'Organization',
  },
  {
    path: '/account/2fa',
    view: () => <Navigate to="/account" replace />, // temporary redirect from /account/2fa to /account (2fa section is disabled). When it will be rewtored -> view: TwoFA.
    layout: 'app',
    permission: 'editor',
    title: 'Manage 2FA',
  },
  {
    path: '/account/users',
    view: Users,
    layout: 'app',
    permission: 'admin',
    title: 'Users',
  },
  {
    path: '/account/subscription',
    view: Subscription,
    layout: 'app',
    permission: 'admin',
    title: 'Subscription',
  },
  {
    path: '/account/buy-volume',
    view: BuyVolume,
    layout: 'plain',
    permission: 'owner',
    requireActivePlan: true,
    title: 'Buy Volume',
  },
  {
    path: '/account/change-plan',
    view: ChangePlan,
    layout: 'plain',
    permission: 'owner',
    requireActivePlan: true,
    title: 'Change Plan',
  },
  {
    path: '/account/project-access',
    view: ProjectAccess,
    layout: 'app',
    permission: 'admin',
    title: 'Project Access',
  },
];

export default Routes;
